import { render, staticRenderFns } from "./ScopeActionsPanel.vue?vue&type=template&id=455362f3&scoped=true"
import script from "./ScopeActionsPanel.vue?vue&type=script&lang=js"
export * from "./ScopeActionsPanel.vue?vue&type=script&lang=js"
import style0 from "./ScopeActionsPanel.vue?vue&type=style&index=0&id=455362f3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455362f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455362f3')) {
      api.createRecord('455362f3', component.options)
    } else {
      api.reload('455362f3', component.options)
    }
    module.hot.accept("./ScopeActionsPanel.vue?vue&type=template&id=455362f3&scoped=true", function () {
      api.rerender('455362f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope/ScopeActionsPanel.vue"
export default component.exports